<template>
  <v-container>
    <br>
    <v-row>
      <v-col cols="2" class="align-vertical no-padding">
        <span>Time Mode:</span>
      </v-col>
      <v-col cols="8" class="align-vertical no-padding">
        <v-radio-group
          v-model="selectedTimeMode"
          row
        >
          <v-radio
            label="GPS"
            value="gps"
          ></v-radio>
          <v-radio
            label="Manual"
            value="manual"
            :disabled="isDisabled"
          ></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <br>
    <BorderedContainer
      label="Time Zone">
      <br>
      <v-row>
        <v-col cols="2" class="align-vertical no-padding">
          <span>Hours:</span>
        </v-col>
        <v-col cols="2" class="align-vertical no-padding">
          <v-select 
            v-model="selectedTZHours"
            :items="tzHours"
            item-value="xml"
            item-text="label"
            @change="tzChangeListener"
          />
        </v-col>
        <v-col cols="2" class="align-vertical no-padding">
          <span>Minutes:</span>
        </v-col>
        <v-col cols="2" class="align-vertical no-padding">
          <v-select 
            v-model="selectedTZMins"
            :items="tzMinutes"
            item-value="label"
            item-text="label"
            @change="tzChangeListener"
          />
        </v-col>
      </v-row>
    </BorderedContainer>
    <br>
    <v-row>
      <v-col cols="12" class="align-vertical no-padding">
        <v-checkbox
          v-model="dstEnabled"
          label="Use Daylight Saving Time"
          @change="parseNewVal($event, 'dstToggle', 'Date/Time / Use Daylight Saving Time')"
        />
      </v-col>
    </v-row>
    <br>
    <BorderedContainer
      label="Time Zone">
      <br>
      <v-row>
        <v-col cols="2" class="align-vertical no-padding">
          <span>DST Offset:</span>
        </v-col>
        <v-col cols="2" class="align-vertical no-padding">
          <v-select 
            v-model="selectedDSTOffset"
            :items="dstOffsetMap"
            @change="parseNewVal($event, 'dstOffset', 'Date/Time / DST Offset')"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2" class="align-vertical no-padding">
          <span>DST Start:</span>
        </v-col>
        <v-col cols="3" class="align-vertical no-padding">
          <v-select 
            v-model="selectedDSTStartHour"
            :items="dstHour"
            item-text="label"
            label="Hour"
            @change="parseNewVal($event, 'dstOffsetHour', 'Date/Time / DST Start / Hour')"
          />
        </v-col>
        <v-col cols="3" class="align-vertical no-padding">
          <v-select 
            v-model="selectedDSTStartSunday"
            :items="dstSunday"
            item-text="label"
            label="Sunday of Month"
            @change="parseNewVal($event, 'dstSundaySet', 'Date/Time / DST Start / Sunday of Month')"
          />
        </v-col>
        <v-col cols="3" class="align-vertical no-padding">
          <v-select 
            v-model="selectedDSTStartMonth"
            :items="dstMonth"
            item-text="label"
            label="Month"
            @change="parseNewVal($event, 'dstStartMonth', 'Date/Time / DST Start / Month')"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2" class="align-vertical no-padding">
          <span>DST End:</span>
        </v-col>
        <v-col cols="3" class="align-vertical no-padding">
          <v-select 
            v-model="selectedDSTEndHour"
            :items="dstHour"
            item-text="label"
            label="Hour"
            @change="parseNewVal($event, 'dstEndHour', 'Date/Time / DST End / Hour')"
          />
        </v-col>
        <v-col cols="3" class="align-vertical no-padding">
          <v-select 
            v-model="selectedDSTEndSunday"
            :items="dstSunday"
            item-text="label"
            label="Sunday of Month"
            @change="parseNewVal($event, 'dstEndSunday', 'Date/Time / DST End / Sunday of Month')"
          />
        </v-col>
        <v-col cols="3" class="align-vertical no-padding">
          <v-select 
            v-model="selectedDSTEndMonth"
            :items="dstMonth"
            item-text="label"
            label="Month"
            @change="parseNewVal($event, 'dstEndMonth', 'Date/Time / DST End / Month')"
          />
        </v-col>
      </v-row>

    </BorderedContainer>

  </v-container>
</template>

<script>

// import { Logger } from "aws-amplify";
// const logger = new Logger("Date Time");

import BorderedContainer from '../components/BorderedContainer.vue';

import {deviceConfigMixin} from '@/mixins/deviceConfigMixin.js';

export default {
  name: 'DateTime',
  components: {
    BorderedContainer
  },
  mixins: [deviceConfigMixin],
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedTimeMode: null,
      tzHours: [
        {
          xml: '0',
          label: 'UTC+00'
        },
        {
          xml: '1',
          label: 'UTC+01'
        },
        {
          xml: '2',
          label: 'UTC+02'
        },
        {
          xml: '3',
          label: 'UTC+03'
        },
        {
          xml: '4',
          label: 'UTC+04'
        },
        {
          xml: '5',
          label: 'UTC+05'
        },
        {
          xml: '6',
          label: 'UTC+06'
        },
        {
          xml: '7',
          label: 'UTC+07'
        },
        {
          xml: '8',
          label: 'UTC+08'
        },
        {
          xml: '9',
          label: 'UTC+09'
        },
        {
          xml: '10',
          label: 'UTC+10'
        },
        {
          xml: '11',
          label: 'UTC+11'
        },
        {
          xml: '12',
          label: 'UTC+12'
        },
        {
          xml: '13',
          label: 'UTC+13'
        },
        {
          xml: '14',
          label: 'UTC+14'
        },
        {
          xml: '-12',
          label: 'URC-12'
        },
        {
          xml: '-11',
          label: 'UTC-11'
        },
        {
          xml: '-10',
          label: 'UTC-10'
        },
        {
          xml: '-9',
          label: 'UTC-09'
        },
        {
          xml: '-8',
          label: 'UTC-08'
        },
        {
          xml: '-7',
          label: 'UTC-07'
        },
        {
          xml: '-6',
          label: 'UTC-06'
        },
        {
          xml: '-5',
          label: 'UTC-05'
        },
        {
          xml: '-4',
          label: 'UTC-04'
        },
        {
          xml: '-3',
          label: 'UTC-03'
        },
        {
          xml: '-2',
          label: 'UTC-02'
        },
        {
          xml: '-1',
          label: 'UTC-01'
        }
      ],
      tzMinutes: [
        {
          xml: '0',
          label: '0'
        },
        {
          xml: '1',
          label: '15'
        },
        {
          xml: '2',
          label: '45'
        }
      ],
      dstEnabled: Boolean,
      dstOffsetMap: [
        0,
        15,
        30,
        45,
        60
      ],
      selectedDSTOffset: '',
      dstSunday: [
        {
          xml: 'first',
          label: 'First'
        },
        {
          xml: 'second',
          label: 'Second'
        },
        {
          xml: 'third',
          label: 'Third'
        },
        {
          xml: 'fourth',
          label: 'Fourth'
        },
        {
          xml: 'last',
          label: 'Last'
        }
      ],
      dstMonth: [
        {
          xml: '0',
          label: 'Jan'
        },
        {
          xml: '1',
          label: 'Feb'
        },
        {
          xml: '2',
          label: 'Mar'
        },
        {
          xml: '3',
          label: 'Apr'
        },
        {
          xml: '4',
          label: 'May'
        },
        {
          xml: '5',
          label: 'Jun'
        },
        {
          xml: '6',
          label: 'Jul'
        },
        {
          xml: '7',
          label: 'Aug'
        },
        {
          xml: '8',
          label: 'Sep'
        },
        {
          xml: '9',
          label: 'Oct'
        },
        {
          xml: '10',
          label: 'Nov'
        },
        {
          xml: '11',
          label: 'Dec'
        }
      ],
      dstHour: [
        {
          xml: '1',
          label: '1AM'
        },
        {
          xml: '2',
          label: '2AM'
        },
        {
          xml: '3',
          label: '3AM'
        }
      ],
      selectedDSTStartHour: '',
      selectedDSTStartMonth: '',
      selectedDSTStartSunday: '',
      selectedDSTEndHour: '',
      selectedDSTEndMonth: '',
      selectedDSTEndSunday: '',
      selectedTZHours: '',
      selectedTZMins: '',

      manualTzUpdate: false
    }
  },
  computed: {
    timeMode() {
      return this.config.device_config.system[0].time[0].mode[0];
    },
    useDST() {
      return JSON.parse(this.config.device_config.system[0].time[0].dstEnable[0].toLowerCase());
    },
    dstOffset() {
      return parseInt(this.config.device_config.system[0].time[0].dstInfo[0].offset[0]);
    },
    dstStartHour() {
      return this.config.device_config.system[0].time[0].dstInfo[0].begin[0].hour[0];
    },
    dstStartMonth() {
      return this.config.device_config.system[0].time[0].dstInfo[0].begin[0].month[0];
    },
    dstStartSunday() {
      return this.config.device_config.system[0].time[0].dstInfo[0].begin[0].sunday[0];
    },
    dstEndHour() {
      return this.config.device_config.system[0].time[0].dstInfo[0].end[0].hour[0];
    },
    dstEndMonth() {
      return this.config.device_config.system[0].time[0].dstInfo[0].end[0].month[0];
    },
    dstEndSunday() {
      return this.config.device_config.system[0].time[0].dstInfo[0].end[0].sunday[0];
    },
    timezone() {
      return (parseInt(this.selectedTZHours * 60) + parseInt(this.selectedTZMins));
    },
    initTimezone() {
      let initVal = parseInt(this.config.device_config.system[0].time[0].timezone[0]);

      return initVal;
    },
    isDisabled() {
      return this.timeMode === 'gps' ? true : false
    },
    mapList() {
      const list = [this.tzHours, this.tzMinutes, this.dstSunday, this.dstMonth, this.dstHour];

      return list.flat();
    }
  },
  watch: {
    timezone(val) {
      if (!this.manualTzUpdate) return
      this.parseNewVal(val, 'timezone', 'Date/Time / Time Zone')
    }
  },
  mounted() {
    this.mapValues();
  },
  methods: {
    tzChangeListener() {
      this.manualTzUpdate = true;
    },

    mapValues() {
      this.selectedTimeMode = this.timeMode;
      this.dstEnabled = this.useDST;
      this.selectedDSTOffset = this.dstOffset;

      this.selectedDSTStartHour = this.preSelectDropdown(this.dstHour, this.dstStartHour);
      this.selectedDSTStartMonth = this.preSelectDropdown(this.dstMonth, this.dstStartMonth);
      this.selectedDSTStartSunday = this.preSelectDropdown(this.dstSunday, this.dstStartSunday);

      this.selectedDSTEndHour = this.preSelectDropdown(this.dstHour, this.dstEndHour);
      this.selectedDSTEndMonth = this.preSelectDropdown(this.dstMonth, this.dstEndMonth);
      this.selectedDSTEndSunday = this.preSelectDropdown(this.dstSunday, this.dstEndSunday);

      // TZ mapping
      this.calcTimezone();

    },
    calcTimezone() {
      let setHour;
      let setMin;

      for (let hour of this.tzHours) {
        for (let min of this.tzMinutes) {
          let res = (parseInt(hour.xml) * 60) + parseInt(min.label);

          if (res == this.initTimezone)  {
            setHour = hour.xml;
            setMin = min.label; 

            break;
          }
        }
      }
  
      this.selectedTZHours = setHour;
      this.selectedTZMins = setMin; 
    },
    preSelectDropdown(array, val) {
      let item = array.find(option => {
        return option.xml === val;
      });
      
      return item;
    },
    parseNewVal(val, id, label) {
      let payload = {
        newValue: this.returnMappedVal(val, [this.dstOffsetMap, this.dstMonth, this.dstHour, this.dstSunday]),
        key: this.configPropMapper(id),
        label: label
      }

      this.$emit('settingsUpdated', payload, this.mapList);
    },
    configPropMapper(key) {
      let map = {
        'timezone': 'device_config.system[0].time[0].timezone[0]',
        'dstToggle': 'device_config.system[0].time[0].dstEnable[0]',
        'dstOffset': 'device_config.system[0].time[0].dstInfo[0].offset[0]',
        'dstOffsetHour': 'device_config.system[0].time[0].dstInfo[0].begin[0].hour[0]',
        'dstSundaySet': 'device_config.system[0].time[0].dstInfo[0].begin[0].sunday[0]',
        'dstStartMonth': 'device_config.system[0].time[0].dstInfo[0].begin[0].month[0]',
        'dstEndHour': 'device_config.system[0].time[0].dstInfo[0].end[0].hour[0]',
        'dstEndSunday': 'device_config.system[0].time[0].dstInfo[0].end[0].sunday[0]',
        'dstEndMonth': 'device_config.system[0].time[0].dstInfo[0].end[0].month[0]'
      }

      return map[key];
    }
  }
}
</script>

<style lang="scss">
  .align-vertical {
    justify-content: left;
    align-items: center;
    display: flex;
  }
  .no-padding {
    padding: 0 .5em !important;
    margin: 0 !important;
  }
  .v-input--selection-controls {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
  // .v-application--is-ltr .v-messages {
  //   display: none !important;
  // }
</style>